export default __webpack_public_path__ + "static/media/real_vision.dd1283f3.svg";